import { FC } from 'react';
import cx from 'classnames';
import { TPatronLevel } from '../../../common/patron';

export interface IPatronLabelProps {
  className?: string;
}

const PatronLabel: FC<IPatronLabelProps & TPatronLevel> = (props) => {
  const { level, name, className } = props;

  return (
    <div
      className={cx(
        'patron-level',
        'patron-level-bg',
        `patron-level-bg--${level}`,
        'rio-border-radius--xx-small',
        'slds-text-align--center',
        'rio-text-shadow--normal',
        className
      )}
    >
      {name}
    </div>
  );
};

export default PatronLabel;
